export function setupInputMasks() {
  const nameInput = document.getElementById('name') as HTMLInputElement | null;
  const birthInput = document.getElementById('birthdate') as HTMLInputElement | null;
  const cpfInput = document.getElementById('cpf') as HTMLInputElement | null;

  nameInput?.addEventListener('input', () => {
    nameInput.value = nameInput.value.replace(/[^a-zA-ZÀ-ÿ\s]/g, '');
  });

  birthInput?.addEventListener('input', () => {
    let value = birthInput.value.replace(/\D/g, '');

    if (value.length > 8) value = value.slice(0, 8);

    if (value.length > 4) {
      value = value.replace(/(\d{2})(\d{2})(\d{0,4})/, '$1/$2/$3');
    } else if (value.length > 2) {
      value = value.replace(/(\d{2})(\d{0,2})/, '$1/$2');
    }

    birthInput.value = value;
  });

  cpfInput?.addEventListener('input', () => {
    let rawValue = cpfInput.value;

    let value = rawValue.replace(/[^a-zA-Z0-9]/g, '');

    const hasLetters = /[a-zA-Z]/.test(value);

    if (!hasLetters) {
      value = value.slice(0, 11);

      if (value.length > 9) {
        value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, '$1.$2.$3-$4');
      } else if (value.length > 6) {
        value = value.replace(/(\d{3})(\d{3})(\d{0,3})/, '$1.$2.$3');
      } else if (value.length > 3) {
        value = value.replace(/(\d{3})(\d{0,3})/, '$1.$2');
      }
    } else {
      value = value.slice(0, 20);
    }

    cpfInput.value = value;
  });
}